module.exports = __webpack_public_path__ + "media/images/gn_icon03-e830077a23bb18fcf96fdbcac8866ecb.png";